/**
 * WebCodecs H.264 encode support, checked without loading the encoder chunk.
 * The encoder repeats the check for the real clip size before it encodes.
 */

/** Constrained Baseline, level 3.1: the lowest profile that carries a 720p clip. */
const PROBE_CONFIG = {
    codec: 'avc1.42e01f',
    width: 1280,
    height: 720,
    bitrate: 1000000,
    framerate: 30,
};

/**
 * @param {typeof globalThis} [scope]
 * @returns {Promise<boolean>}
 */
export async function supportsVideoEncode(scope = globalThis) {
    const encoder = scope.VideoEncoder;
    if (typeof encoder?.isConfigSupported !== 'function' || typeof scope.VideoDecoder !== 'function') {
        return false;
    }
    try {
        const result = await encoder.isConfigSupported(PROBE_CONFIG);
        return result?.supported === true;
    } catch {
        return false;
    }
}
